export enum AccountViewState {
  HOME,
  PROFILE,
  SPORTS,
  PRIVACY,
  MESSAGES,
  MESSAGE,
}
